function MenuAula4() {
  

    return (
      <>
        <nav>
            <ul>
              <li><a href="#Oque-é-POST-CSS?">O que é o POST CSS?</a></li>
              <li><a href="#Como-funciona-o-POST-CSS">Como funciona o POST CSS</a></li>
              <li><a href="#POST-CSS-Documentação-mais-detalhes">POST CSS, Documentação</a></li>
              <li><a href="#POST CSS Plugins">POST CSS Plugins</a></li>
            </ul>
          </nav>
      </>
    );
  }
  
  export default MenuAula4;